// TextEditor.tsx
import React, { useEffect, useRef } from 'react';
import { useEditor, EditorContent, Editor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';

interface TextEditorProps { readOnly: boolean, onUpdate: (payload: { editor: Editor }) => void }

const TextEditor: React.FC<TextEditorProps> = ({ onUpdate, readOnly }) => {
    const cb = useRef(onUpdate);
    useEffect(() => { cb.current = onUpdate; }, [onUpdate]);

    const editor = useEditor({
        extensions: [StarterKit, Placeholder.configure({ placeholder: 'Write something…' })],
        content: '<p></p>',
    });

    useEffect(() => {
        if (!editor) return;
        const notify = () => cb.current({ editor });
        if (editor.view) notify(); else queueMicrotask(() => editor.view && notify());
        editor.on('update', notify);
        editor.on('selectionUpdate', notify);
        return () => { editor.off('update', notify); editor.off('selectionUpdate', notify); };
    }, [editor]);

    if (!editor) return null;

    return (
        <div className="tiptap-shell editor">
            <EditorContent readOnly={readOnly} editor={editor} spellCheck={false} className="tiptap-editor" />
        </div>
    );
};

export default TextEditor;



